import { useState, useRef, useEffect, type FormEvent } from "react";

interface MessageInputProps {
  onSend: (message: string) => void;
  disabled?: boolean;
  placeholder?: string;
}

/**
 * Message input form component
 */
export function MessageInput({
  onSend,
  disabled = false,
  placeholder = "Stel een vraag...",
}: MessageInputProps) {
  const [message, setMessage] = useState("");
  const inputRef = useRef<HTMLInputElement>(null);

  // Auto-focus input when enabled
  useEffect(() => {
    if (!disabled && inputRef.current) {
      inputRef.current.focus();
    }
  }, [disabled]);

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();

    const trimmed = message.trim();
    if (!trimmed || disabled) return;

    onSend(trimmed);
    setMessage("");
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="border-t border-outline-variant bg-surface-container-lowest p-4"
    >
      <div className="flex gap-2 max-w-4xl mx-auto">
        <input
          ref={inputRef}
          type="text"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          disabled={disabled}
          placeholder={placeholder}
          className="flex-1 px-4 py-3 border border-outline-variant bg-surface-container-lowest text-on-surface rounded-full focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent disabled:bg-surface-container disabled:cursor-not-allowed placeholder:text-on-surface-variant/60"
        />
        <button
          type="submit"
          disabled={disabled || !message.trim()}
          className="px-6 py-3 bg-primary text-on-primary rounded-full hover:brightness-110 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 disabled:bg-outline-variant disabled:text-surface disabled:cursor-not-allowed transition-colors shadow-1"
        >
          Verstuur
        </button>
      </div>
    </form>
  );
}
